<template>
  <div class="user_home">
    <div class="user_top">
      <div class="login_">
        <router-link to="/user/userSetInfo"
          ><img
            class="img"
            :src="
              info?.avatar
                ? info?.avatar == ''
                  ? ologin
                  : info?.avatar
                : nologin
            "
        /></router-link>
        <div class="option">
          <span v-if="info?.nickname" class="nickname">{{
            info.nickname
          }}</span>
          <router-link to="/user/login" v-else>登录/注册</router-link>
          <router-link to="/user/userSet"
            ><img src="@/static/images/icon_white_setting.png"
          /></router-link>
        </div>
      </div>
      <div class="user_"></div>
    </div>
    <div class="user_order containerWidth">
      <div class="head">
        <span>账户资产</span>
      </div>
      <div class="content">
        <div
          class="item"
          @click="router_chenge('jump', '/user/userCommission')"
        >
          <div>
            <p class="title">返现金额</p>
            <p class="number">{{ info?.brokerage_price || "—" }}</p>
          </div>
          <van-icon name="arrow" />
        </div>
        <div class="item" @click="router_chenge('jump', '/user/userDraw')">
          <div>
            <p class="title">我的积分</p>
            <p class="number">{{ info?.integral || "—" }}</p>
          </div>
          <van-icon name="arrow" />
        </div>
      </div>
    </div>
    <div class="user_order user_activity containerWidth">
      <div class="content">
        <div class="item">
          <router-link to="/user/userBalance">
            <p class="title">电子钱包 <van-icon name="arrow" /></p>
            <p class="number">{{ info?.nickname ? "查看详情" : "暂未登录" }}</p>
          </router-link>
        </div>
        <div class="item">
          <router-link to="/user/userShare">
            <p class="title">邀请好友 <van-icon name="arrow" /></p>
            <p class="number">消费返现领不停</p>
          </router-link>
        </div>
      </div>
    </div>
    <div class="user_order order_list containerWidth">
      <div class="head">
        <span>商城订单</span>
      </div>
      <div class="content">
        <div class="item">
          <van-badge content="" class="van-badge-right">
            <router-link to="/user/userOrder?type=">
              <p class="img"><img src="@/static/images/order_all.png" /></p>
              <p class="text">全部</p>
            </router-link>
          </van-badge>
        </div>
        <div class="item">
          <van-badge content="" class="van-badge-right">
            <router-link to="/user/userOrder?type=0">
              <p class="img"><img src="@/static/images/order_unpay.png" /></p>
              <p class="text">待付款</p>
            </router-link>
          </van-badge>
        </div>
        <div class="item">
          <van-badge content="" class="van-badge-right">
            <router-link to="/user/userOrder?type=1">
              <p class="img"><img src="@/static/images/order_unsend.png" /></p>
              <p class="text">待发货</p>
            </router-link>
          </van-badge>
        </div>
        <div class="item">
          <van-badge content="" class="van-badge-right">
            <router-link to="/user/userOrder?type=2">
              <p class="img">
                <img src="@/static/images/order_unreceived.png" />
              </p>
              <p class="text">待收货</p>
            </router-link>
          </van-badge>
        </div>
      </div>
    </div>
    <div class="user_order containerWidth" id="tables">
      <div class="content">
        <router-link to="/help">
          <p>
            <img src="@/static/images/icon_mine_help_center.png" />
            <span>帮助中心</span>
          </p>
          <van-icon name="arrow" />
        </router-link>
        <a @click="show = true">
          <p>
            <img src="@/static/images/icon_mine_customer.png" />
            <span>联系客服</span>
          </p>
          <van-icon name="arrow" />
        </a>
        <router-link v-if="info?.user_type == 'vip'" to="/user/vipOrder">
          <p>
            <img src="@/static/images/icon_rb_home_press.png" />
            <span>收货商</span>
          </p>
          <van-icon name="arrow" />
        </router-link>
      </div>
    </div>
    <van-action-sheet
      @select="select"
      v-model="show"
      :actions="actions"
      cancel-text="取消"
      :description="customer_time"
      close-on-click-action
    />
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import userMixi from "@/Mixin/index";
import api from "@/request/api";
export default {
  name: "UserHome",
  mixins: [userMixi],
  data() {
    return {
      show: false,
      customer_time: "",
      actions: [
        // { name: "电话客服", params: "12345679", is_tel: true },
        // { name: "在线客服", params: "http://www.baidu.com", is_tel: false },
      ],
    };
  },
  mounted() {
    this.getConfigs();
    this.getUserinfo();
  },
  //
  computed: {
    ...mapGetters(["info"]),
  },
  methods: {
    getConfigs() {
      try {
        var that = this;
        api
          .getConfig()
          .then((result) => {
            if (result.status === 200) {
              that.actions = result.data.actions.filter(
                (item) => item.status == "1"
              );
              that.customer_time = result.data.customer_time;
            } else {
              // document.title = "云小猪-" + to.meta.web_title;
            }
            console.log(result);
          })
          .catch((err) => {
            throw err;
          });
      } catch (error) {
        console.error(error);
      }
    },
    select(e) {
      if (e.type === "url") {
        const id = this.info?.uid || "";
        const name = this.info?.phone || "";
        const avatar = this.info?.avatar || "";
        let u = e.params
          .replace(/\${id}/g, encodeURIComponent(id))
          .replace(/\${name}/g, encodeURIComponent(name))
          .replace(/\${avatar}/g, encodeURIComponent(avatar));

        // console.log(u);
        window.location.href = u;
      } else {
        this.$dialog.alert({
          message: `
        <img src='${e.params}' width='100%'/>
      `,
        });
      }
    },
    router_chenge(type, data) {
      this.$routerBack(this, type, data);
    },
  },
};
</script>
<style scoped lang="scss">
@import "./index.scss";
</style>
